import { createRouter, createWebHistory } from 'vue-router'

// 使用懒加载导入组件
const Home = () => import('../views/Home.vue')
const About = () => import('../views/About.vue')
const PracticeAreas = () => import('../views/PracticeAreas.vue')
const Professionals = () => import('../views/Professionals.vue')
const ProfessionalDetail = () => import('../views/ProfessionalDetail.vue')
const News = () => import('../views/News.vue')
const NewsDetail = () => import('../views/NewsDetail.vue')
const Contact = () => import('../views/Contact.vue')
const Legal = () => import('../views/Legal.vue')
const Privacy = () => import('../views/Privacy.vue')
const Sitemap = () => import('../views/Sitemap.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/practice-areas',
    name: 'PracticeAreas',
    component: PracticeAreas
  },
  {
    path: '/professionals',
    name: 'Professionals',
    component: Professionals
  },
  {
    path: '/professionals/:id',
    name: 'ProfessionalDetail',
    component: ProfessionalDetail
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/legal',
    name: 'Legal',
    component: Legal
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: Sitemap
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router

